import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponentV2 } from '../../../../../shared/components/icon-component/icon.component';
import { UnpaidPaymentNoteEntry } from '../../unpaid-payments-calculation.service';
import { UnpaidPaymentsNotesModalData } from '../../unpaid-payments-modal.types';

@Component({
  selector: 'app-unpaid-payments-notes-modal',
  standalone: true,
  imports: [CommonModule, IconComponentV2],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './unpaid-payments-notes-modal.component.html',
})
export class UnpaidPaymentsNotesModalComponent {
  private readonly dialogData = inject<UnpaidPaymentsNotesModalData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<UnpaidPaymentsNotesModalComponent, void>);

  readonly title = this.dialogData.title ?? 'Notes';
  readonly emptyMessage = this.dialogData.emptyMessage ?? 'No notes found for this payment.';
  readonly entries: UnpaidPaymentNoteEntry[] = this.dialogData.entries ?? [];

  close(): void {
    this.dialogRef.close();
  }
}
